import React, { Fragment } from 'react'
import { Box } from '@mui/material'
import { StepperShell } from '../../components/_WMS/Stepper'
import { AsnLocateState } from './types'
import { ScanStep } from './steps/ScanStep'
import { ResultsStep } from './steps/ResultsStep'
import { UnknownIdStep } from './steps/UnknownIdStep'
import { LpnStep } from './steps/LpnStep'
import { LocateStepV2 } from './steps/LocateStepV2'

const AsnLocatePage: React.FC = () => {
  const initialSharedState: AsnLocateState = {
    scanType: 'ASN',
    scanValue: '',
    results: [],
    isLoading: false,
    lpnList: [],
    lpnAsnId: null,
    selectedLpn: null,
    selectedResult: null
  }

  return (
    <Fragment>
      <Box sx={{ mx: -2, mt: -3, mb: -3, minHeight: 'calc(var(--app-vh) - 64px)', backgroundColor: '#FFF' }}>
      <StepperShell<AsnLocateState> backButtonWithText
        steps={[
          (props) => <ScanStep {...props} />,               // 0 - búsqueda Inicial
          (props) => <ResultsStep {...props} />,             // 1 - Multiples ASN encontradas
          (props) => <UnknownIdStep {...props} />,            // 2 - Al presionar no conozco el numero
          (props) => <LpnStep {...props} />,                  // 3 - si un ASN tiene mas de un LPN
          (props) => <LocateStepV2 {...props} />              // 4 - Putaway simplificado
        ]}
        initialSharedState={initialSharedState}
      />
      </Box>
    </Fragment>
  )
}

export default AsnLocatePage
